export const CustomLabel = ({ text, required = false }) => (
  <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
    {text} {required && <span className="text-red-400">*</span>}
  </label>
);
